import BillingsOrderForwardBillingsListRequest, {
  BillingsOrderForwardBillingsListQueryParams,
} from "./billings-order-forward-billings-list.request";

const createQueryParams = (
  request: BillingsOrderForwardBillingsListRequest,
): BillingsOrderForwardBillingsListQueryParams => {
  return {
    limit: request.limit,
    offset: request.offset,
    consumer: request.consumer,
    humanId: request.humanId,
    order: request.order,
    producer: request.producer,
    startTimeSince: request.startTimeSince,
    startTimeTo: request.startTimeTo,
    status: request.status,
    taxiCorporationId: request.taxiCorporationId,
  };
};

const billingsOrderForwardBillingsListRequestFactory = {
  createQueryParams,
};

export default billingsOrderForwardBillingsListRequestFactory;
